module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"zh-Hans":{"document-title":"购买相关书籍"},"zh-Hant":{}}')
  delete Component.options._Ctor
}
